"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require("common-utilities/src/collection_utility");

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require("./global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require("../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _currency_utility = require("../../../packages/common-utilities/src/currency_utility");

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _formatted_number = require("./global_components/formatted_number");

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _moment = require("moment/moment");

var _moment2 = _interopRequireDefault(_moment);

var _button = require("./global_components/button");

var _button2 = _interopRequireDefault(_button);

var _tracking_utility = require("../../../packages/common-utilities/src/tracking_utility");

var _custom_date_range_component = require("./custom_date_range_component");

var _custom_date_range_component2 = _interopRequireDefault(_custom_date_range_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericFundDividendsCapitalGainsCard = function (_React$Component) {
  _inherits(GenericFundDividendsCapitalGainsCard, _React$Component);

  function GenericFundDividendsCapitalGainsCard(props) {
    _classCallCheck(this, GenericFundDividendsCapitalGainsCard);

    var _this = _possibleConstructorReturn(this, (GenericFundDividendsCapitalGainsCard.__proto__ || Object.getPrototypeOf(GenericFundDividendsCapitalGainsCard)).call(this, props));

    _this.mapData = function (data) {
      if (_this.doesDataPointContains('REIT_DIVIDEND_HISTORY')) {
        return _this.mapMonthByMonthData(_this.props.data);
      }
      return data;
    };

    _this.getMonthByMonthColumnHeaderLabels = function () {
      return {
        "Jan": _string_utility2.default.renderFormattedLabel("Jan", "month-short-Jan"),
        "Feb": _string_utility2.default.renderFormattedLabel("Feb", "month-short-Feb"),
        "Mar": _string_utility2.default.renderFormattedLabel("Mar", "month-short-Mar"),
        "Apr": _string_utility2.default.renderFormattedLabel("Apr", "month-short-Apr"),
        "May": _string_utility2.default.renderFormattedLabel("May", "month-short-May"),
        "Jun": _string_utility2.default.renderFormattedLabel("Jun", "month-short-Jun"),
        "Jul": _string_utility2.default.renderFormattedLabel("Jul", "month-short-Jul"),
        "Aug": _string_utility2.default.renderFormattedLabel("Aug", "month-short-Aug"),
        "Sep": _string_utility2.default.renderFormattedLabel("Sep", "month-short-Sep"),
        "Oct": _string_utility2.default.renderFormattedLabel("Oct", "month-short-Oct"),
        "Nov": _string_utility2.default.renderFormattedLabel("Nov", "month-short-Nov"),
        "Dec": _string_utility2.default.renderFormattedLabel("Dec", "month-short-Dec")
      };
    };

    _this.mapMonthByMonthData = function () {
      var distributionData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var fieldNameFromColumnLabels = Object.keys(_this.getMonthByMonthColumnHeaderLabels());
      var orderedMap = new Map();
      distributionData.filter(function (data) {
        return data.recordDate;
      }).forEach(function (data) {
        var recordDate = _moment2.default.utc(data.recordDate);
        var year = recordDate.year();
        var month = recordDate.month();
        if (!orderedMap.has(year)) {
          orderedMap.set(year, _defineProperty({}, month, data));
        } else {
          orderedMap.get(year)[month] = data;
        }
      });

      return Array.from(orderedMap.entries()).map(function (entry) {
        var year = entry[0];
        var monthData = entry[1];
        return fieldNameFromColumnLabels.reduce(function (prev, monthLabel, index) {
          var currentMonthAmount = (monthData[index] || {}).dividendAmount;
          return _extends(_defineProperty({}, monthLabel, currentMonthAmount), prev);
        }, { "Year": year });
      });
    };

    var toDate = _date_formatter2.default.getDateInSpecificFormat((0, _moment2.default)(Date.now()).subtract(1, 'days'), "YYYY-MM-DD");
    var fromDate = (0, _ramda.isNil)(_this.props.shareclassData) ? Date.now() : _date_formatter2.default.getDateInSpecificFormat(_this.props.shareclassData.shareClassInceptionDate, "YYYY-MM-DD");

    _this.state = {
      filteredData: _this.mapData(_this.props.data),
      toDate: toDate,
      fromDate: fromDate
    };
    return _this;
  }

  _createClass(GenericFundDividendsCapitalGainsCard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.data !== prevProps.data) {
        this.setState({
          filteredData: this.mapData(this.props.data)
        });
      }
    }
  }, {
    key: "populateDividendYieldColumns",
    value: function populateDividendYieldColumns() {
      var dividendFields = {
        "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", 'pdp-dividend-subheader-ex-date'),
        "reinvestNavPr": _string_utility2.default.renderFormattedLabel("REINVEST NAV", 'pdp-dividend-subheader-reinvest-nav'),
        "dividendAmount": _string_utility2.default.renderFormattedLabel("DIVIDEND PAID", 'pdp-dividend-subheader-dividend-amount', { fundTypeCode: this.props.fundTypeCode })
      };
      if (this.doesDataPointContains('DIVIDEND_CARD_WITH_RECORD_DATE') || this.doesDataPointContains('CAPITAL_GAINS_CARD_WITH_RECORD_DATE')) {
        dividendFields = {
          "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", 'pdp-dividend-subheader-ex-date'),
          "recordDate": _string_utility2.default.renderFormattedLabel("RECORD DATE", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("PAY DATE", 'pdp-dividend-subheader-pay-date'),
          "dividendAmount": _string_utility2.default.renderFormattedLabel("DIVIDEND PAID", 'pdp-dividend-subheader-dividend-amount', { fundTypeCode: this.props.fundTypeCode })
        };
      }
      if (this.doesDataPointContains('DIVIDEND_HISTORY_TAB')) {
        dividendFields = {
          "dividendAmount": _string_utility2.default.renderFormattedLabel("Amount", 'pdp-dividend-subheader-amount'),
          "recordDate": _string_utility2.default.renderFormattedLabel("Record date", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("Payment date", 'pdp-dividend-subheader-pay-date')
        };
        var dividendYieldKey = this.doesDataPointContains("ANNUALISED_DIVIDEND_YIELD") ? _string_utility2.default.renderFormattedLabel("Annualised dividend yield", 'pdp-dividend-subheader-annualised-dividend-yield') : _string_utility2.default.renderFormattedLabel("Dividend yield", 'pdp-dividend-subheader-dividend-yield');
        dividendFields["annualizedDividendYieldPercentage"] = dividendYieldKey;
      }
      if (this.doesDataPointContains('DIVIDEND_HISTORY_TAB_WITH_EX_DATE')) {
        dividendFields = {
          "dividendAmount": _string_utility2.default.renderFormattedLabel("Amount", 'pdp-dividend-subheader-amount'),
          "exDate": _string_utility2.default.renderFormattedLabel("Ex-date", 'pdp-dividend-subheader-ex-date'),
          "recordDate": _string_utility2.default.renderFormattedLabel("Record date", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("Payment date", 'pdp-dividend-subheader-pay-date')
        };
        var _dividendYieldKey = this.doesDataPointContains("ANNUALISED_DIVIDEND_YIELD") ? _string_utility2.default.renderFormattedLabel("Annualised dividend yield", 'pdp-dividend-subheader-annualised-dividend-yield') : _string_utility2.default.renderFormattedLabel("Dividend yield", 'pdp-dividend-subheader-dividend-yield');
        dividendFields["annualizedDividendYieldPercentage"] = _dividendYieldKey;
      }
      if (this.doesDataPointContains('EMEA_DIVIDEND_HISTORY')) {
        dividendFields = {
          "exDate": _string_utility2.default.renderFormattedLabel("Ex-date", 'pdp-dividend-subheader-ex-date'),
          "recordDate": _string_utility2.default.renderFormattedLabel("Record date", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("Payment date", 'pdp-dividend-subheader-pay-date'),
          "dividendAmount": _string_utility2.default.renderFormattedLabel("Dividend amount", 'pdp-dividend-subheader-dividend-amount', { fundTypeCode: this.props.fundTypeCode }),
          "dividendRate": _string_utility2.default.renderFormattedLabel("Dividend yield", 'pdp-dividend-subheader-dividend-yield'),
          "annualizedDividendYieldPercentage": _string_utility2.default.renderFormattedLabel("Annualised yield", 'pdp-dividend-subheader-annualized-yield')
        };
      }
      if (this.doesDataPointContains('EMEA_DIVIDEND_YIELD')) {
        dividendFields = {
          "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", 'pdp-dividend-subheader-ex-date'),
          "recordDate": _string_utility2.default.renderFormattedLabel("Record date", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("Payment date", 'pdp-dividend-subheader-pay-date'),
          "dividendAmount": _string_utility2.default.renderFormattedLabel("Amount", 'pdp-dividend-subheader-amount'),
          "dividendRate": _string_utility2.default.renderFormattedLabel("Dividend yield", 'pdp-dividend-subheader-dividend-yield'),
          "annualizedDividendYieldPercentage": _string_utility2.default.renderFormattedLabel("Annualised dividend yield", 'pdp-dividend-subheader-annualised-dividend-yield')
        };
      }
      if (this.doesDataPointContains('JP_DIVIDEND_HISTORY')) {
        dividendFields = {
          "exDate": _string_utility2.default.renderFormattedLabel("exDate", 'pdp-dividend-subheader-ex-date'),
          "dividendAmount": _string_utility2.default.renderFormattedLabel("Amount", 'pdp-dividend-subheader-amount'),
          "navPrice": _string_utility2.default.renderFormattedLabel("Amount", 'pdp-dividend-subheader-nav')
        };
      }

      if (this.doesDataPointContains('AU_ETF_DIVIDEND_HISTORY')) {
        dividendFields = {
          "dividendAmount": _string_utility2.default.renderFormattedLabel("AMOUNT", 'pdp-dividend-subheader-amount'),
          "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", 'pdp-dividend-subheader-ex-date'),
          "reinvestNavPr": _string_utility2.default.renderFormattedLabel("DISTRIBUTION REINVESTMENT PRICE", 'pdp-dividend-subheader-reinvestNavPr'),
          "recordDate": _string_utility2.default.renderFormattedLabel("RECORD DATE", 'pdp-dividend-subheader-record-date'),
          "payDate": _string_utility2.default.renderFormattedLabel("PAYMENT DATE", 'pdp-dividend-subheader-pay-date')
        };
      }
      if (this.doesDataPointContains('REIT_DIVIDEND_HISTORY')) {
        dividendFields = _extends({
          "Year": ""
        }, this.getMonthByMonthColumnHeaderLabels());
      }

      return dividendFields;
    }
  }, {
    key: "populateCapitalGainsColumns",
    value: function populateCapitalGainsColumns() {
      if (this.isEtf()) {
        return {
          "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", "pdp-capital-fields-ex-date"),
          "recordDate": _string_utility2.default.renderFormattedLabel("RECORD DATE", "pdp-capital-fields-record-date"),
          "payDate": _string_utility2.default.renderFormattedLabel("PAY DATE", "pdp-capital-fields-pay-date"),
          "capitalGainShortTerm": _string_utility2.default.renderFormattedLabel("SHORT TERM", "pdp-capital-fields-short-term"),
          "capitalGainLongTerm": _string_utility2.default.renderFormattedLabel("LONG TERM", "pdp-capital-fields-long-term")
        };
      } else {
        return {
          "exDate": _string_utility2.default.renderFormattedLabel("EX-DATE", "pdp-capital-fields-ex-date"),
          "reinvestNavPr": _string_utility2.default.renderFormattedLabel("REINVEST NAV", "pdp-capital-fields-reinvest-nav"),
          "capitalGainShortTerm": _string_utility2.default.renderFormattedLabel("SHORT TERM", "pdp-capital-fields-short-term"),
          "capitalGainLongTerm": _string_utility2.default.renderFormattedLabel("LONG TERM", "pdp-capital-fields-long-term")
        };
      }
    }
  }, {
    key: "isEtf",
    value: function isEtf() {
      return this.doesDataPointContains('DIVIDEND_CARD_WITH_RECORD_DATE') || this.doesDataPointContains('CAPITAL_GAINS_CARD_WITH_RECORD_DATE');
    }
  }, {
    key: "generateTable",
    value: function generateTable(fields, data, dataTestLabel) {
      return _react2.default.createElement(_table_component2.default, {
        tableHeaders: this.generateTableHeaders(dataTestLabel, fields),
        tableRows: this.generateTableRows(data, dataTestLabel, fields),
        tableBodyTest: "",
        activeTab: this.props.active,
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: "generateTableHeaders",
    value: function generateTableHeaders(dataTestLabel) {
      var _this2 = this;

      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var markup = [];
      _collection_utility.CollectionUtility.forEachIndexed(fields, function (value, key) {
        markup.push(_react2.default.createElement(
          "th",
          { className: "border-top-none tag " + _this2.getRightAlignedColumns(key),
            "data-testid": dataTestLabel + "-card-" + key },
          value
        ));
      });

      return markup;
    }
  }, {
    key: "getRightAlignedColumns",
    value: function getRightAlignedColumns(value) {
      var rightAlignedValues = ["reinvestNavPr", "dividendAmount", "capitalGainShortTerm", "capitalGainLongTerm"];

      if (this.doesDataPointContains('EMEA_DIVIDEND_YIELD')) {
        rightAlignedValues = ["payDate", "dividendAmount", "dividendRate", "annualizedDividendYieldPercentage"];
      } else if (this.doesDataPointContains("JP_DIVIDEND_HISTORY")) {
        rightAlignedValues = ["dividendAmount", "navPrice"];
      } else if (this.doesDataPointContains('DIVIDEND_HISTORY_TAB')) {
        rightAlignedValues = ["recordDate", "payDate", "annualizedDividendYieldPercentage"];
      } else if (this.doesDataPointContains("EMEA_DIVIDEND_HISTORY")) {
        rightAlignedValues = ["dividendAmount", "dividendRate", "annualizedDividendYieldPercentage"];
      }

      return rightAlignedValues.indexOf(value) > -1 ? "text-right" : "";
    }
  }, {
    key: "doesDataPointContains",
    value: function doesDataPointContains(visibleDataPointName) {
      return (0, _functional_utility.doesVisibleDataPointContains)(visibleDataPointName, this.props, ["visibleDataPoints"]);
    }
  }, {
    key: "generateTableRows",
    value: function generateTableRows(data, dataTestLabel) {
      var _this3 = this;

      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tableRows = [];
      var tableData = [];

      _collection_utility.CollectionUtility.forEachIndexed(data, function (item, index) {
        var tableRow = _react2.default.createElement(
          "tr",
          { className: "category row-divider",
            "data-testid": dataTestLabel + "-data-" + index },
          tableData
        );

        _collection_utility.CollectionUtility.forEachIndexed(fields, function (value, key) {
          var defaultValue = ["capitalGainShortTerm", "capitalGainLongTerm"].indexOf(key) > -1 ? "0.00000" : "-";
          if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_AMOUNT_ZERO_WITH_2_DP', _this3.props, ["formattingRules"])) {
            defaultValue = "dividendAmount" === key ? 0.00 : "-";
          }
          if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_SIX_DECIMALS', _this3.props, ["formattingRules"])) {
            defaultValue = "dividendAmount" === key ? 0.000000 : "-";
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_DRP_IN_FOUR_DECIMALS', _this3.props, ["formattingRules"])) {
            defaultValue = "reinvestNavPr" === key ? 0.0000 : "-";
          }
          var data = void 0;

          if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_ZERO_DECIMALS', _this3.props, ['formattingRules'])) {
            data = (0, _ramda.isNil)(item[key]) ? defaultValue : item[key];
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_ZERO_IN_FIVE_DECIMALS', _this3.props, ['formattingRules'])) {
            data = item[key] === 0 ? 0 : item[key] || defaultValue;
          } else {
            data = item[key] || defaultValue;
          }

          tableData.push(_react2.default.createElement(
            "td",
            { className: "border-top-none " + _this3.getRightAlignedColumns(key) },
            _this3.formatValue(key, data, _this3.doesDataPointContains('DIVIDEND_HISTORY_TAB') || _this3.doesDataPointContains('EMEA_DIVIDEND_HISTORY') || _this3.doesDataPointContains('REIT_DIVIDEND_HISTORY'))
          ));
        });
        tableRows.push(tableRow);
        tableData = [];
      });

      return tableRows;
    }
  }, {
    key: "formatValue",
    value: function formatValue(value, data, showDividendHistory) {
      if ((0, _ramda.isNil)(data) || data === "-") {
        return "-";
      }
      var formattedValue = data;
      var preventScientificNotation = false;

      if (/date/gi.test(value) && _date_formatter2.default.isValidDate(data)) {
        formattedValue = _date_formatter2.default.getLocalFormattedDate(data);
      } else if (showDividendHistory) {
        if ("annualizedDividendYieldPercentage" === value) {
          formattedValue = _number_utility2.default.formatToPercentWith2FixedDecimals(data);
        } else if ("reinvestNavPr" === value) {
          if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_DRP_IN_FOUR_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = "$" + _number_utility2.default.convertToAmount(data, 4);
          }
        } else if ("dividendRate" === value) {
          formattedValue = _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(data);
        } else if ("dividendAmount" === value || this.getMonthByMonthColumnHeaderLabels()[value]) {
          if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_TWO_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = "$" + _number_utility2.default.convertToNDecimalFixedNumber(data, 2);
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_ZERO_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = _number_utility2.default.convertToAmountWithPreciseRounding(data, 0, 0, false, true);
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_SIX_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = "$" + _number_utility2.default.convertToNDecimalFixedNumber(data, 6);
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_FIVE_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = _number_utility2.default.convertToNDecimalFixedNumber(data, 5);
          } else if ((0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_IN_FOUR_DECIMALS', this.props, ['formattingRules'])) {
            formattedValue = _number_utility2.default.convertToNDecimalFixedNumber(data, 4);
          } else {
            formattedValue = this.props.currencyCode + " " + _number_utility2.default.convertToNDecimalFixedNumber(data, 4);
          }
        } else if ("navPrice" === value) {
          formattedValue = _number_utility2.default.convertToNumberWithCommas(data);
        }
      } else if ("reinvestNavPr" === value) {
        formattedValue = _currency_utility2.default.convertToCurrency(data, null);
      } else if ("dividendAmount" === value) {
        if (data === 0 && (0, _functional_utility.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_ZERO_IN_FIVE_DECIMALS', this.props, ['formattingRules'])) {
          formattedValue = "0.00000";
        } else {
          preventScientificNotation = true;
        }
      }

      return _react2.default.createElement(_formatted_number2.default, { value: formattedValue, numberFormat: this.props.numberFormat, preventScientificNotation: preventScientificNotation });
    }
  }, {
    key: "filterData",
    value: function filterData(fromDate, toDate) {
      var filteredData = _collection_utility.CollectionUtility.filter(this.props.data, function (data) {
        return _moment2.default.utc((0, _moment2.default)(data.recordDate)).isBetween(fromDate, toDate, null, '[]');
      });

      if ((0, _functional_utility.isNilOrEmpty)(filteredData)) {
        return false;
      } else {
        this.setState({
          filteredData: filteredData,
          fromDate: (0, _moment2.default)(fromDate).format("YYYY-MM-DD"),
          toDate: (0, _moment2.default)(toDate).format("YYYY-MM-DD")
        });
        return true;
      }
    }
  }, {
    key: "renderCustomDateRangeDropdown",
    value: function renderCustomDateRangeDropdown() {
      var _this4 = this;

      if (this.doesDataPointContains("DIVIDEND_HISTORY_DOWNLOAD")) {
        var dateRangeArray = [{
          value: '0',
          displayValue: 'Since Inception',
          translationKey: 'since-inception'
        }];
        var validToDate = _date_formatter2.default.getDateInSpecificFormat((0, _moment2.default)(Date.now()).subtract(1, 'days'), "YYYY-MM-DD");
        var validFromDate = _date_formatter2.default.getDateInSpecificFormat(this.props.shareclassData.shareClassInceptionDate, "YYYY-MM-DD");

        return _react2.default.createElement(
          "div",
          { className: "padding-bottom-15" },
          _react2.default.createElement(_custom_date_range_component2.default, {
            id: "dividend-history",
            validFromDate: validFromDate,
            validToDate: validToDate,
            filterData: function filterData(toDate, fromDate) {
              return _this4.filterData(toDate, fromDate);
            },
            tooltip: this.props.tooltip,
            count: 2,
            showDropdown: true,
            updateParent: function updateParent(data) {
              return _this4.updateParent(data);
            },
            dateFormat: 'DD/MM/YYYY',
            dateRangeArray: dateRangeArray,
            breakpoint: this.props.breakpoint,
            visiblePoints: this.props.visibleDataPoints,
            sinceInceptionIsDefault: true })
        );
      } else {
        return null;
      }
    }
  }, {
    key: "updateParent",
    value: function updateParent(updatedData) {
      this.setState({
        filteredFundDistribution: (0, _ramda.isNil)(this.state.filteredFundDistribution) ? this.props.fundDistribution : this.state.filteredFundDistribution
      });
      var updatedState = _extends({}, this.state, updatedData);
      this.setState(updatedState);
    }
  }, {
    key: "trackDataDownload",
    value: function trackDataDownload() {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": 'Dividend History',
        "eventLabel": "download data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: "renderExcelDownload",
    value: function renderExcelDownload() {
      if (this.doesDataPointContains("DIVIDEND_HISTORY_DOWNLOAD")) {
        var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=dividendHistory' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + '&fromDate=' + this.state.fromDate + '&toDate=' + this.state.toDate);
        return _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-dividend-hostory-data",
          downloadURL: excelServiceURL,
          dataTestLink: "dividend-history-excel-download",
          text: _string_utility2.default.renderFormattedLabel("DOWNLOAD CHART DATA", "pdp-download-chart-data", { role: this.props.role }),
          additionalClassName: "mobile-full-width",
          callBack: this.trackDataDownload,
          ariaLabel: "Download Chart Data for Dividend History"
        });
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var disclosureText = void 0,
          headerTitle = void 0,
          headerTitleId = void 0,
          headerTitleLabel = void 0,
          placementId = void 0,
          dataTest = void 0,
          headerLabel = void 0,
          noDataMessage = void 0,
          populatedColumns = void 0,
          dataTestLabel = void 0;
      var isDataEmpty = _collection_utility.CollectionUtility.size(this.state.filteredData) < 1;

      if (this.props.isDividendSchedule) {
        disclosureText = this.doesDataPointContains("REIT_DIVIDEND_HISTORY") ? this.props.disclosures.pdpCardDistributions : this.props.disclosures.pdpCardDividendSchedule;
        if ((0, _ramda.and)(this.doesDataPointContains('APPEND_DISTRIBUTING_CODE_TO_DIVIDEND_SCHEDULE_PLACEMENTID'), !(0, _ramda.isNil)(this.props.distributingCode))) {
          var distributingCodeTitleCase = _string_utility2.default.titleCase(this.props.distributingCode);
          var disclosureKey = "pdpCardDividendSchedule" + distributingCodeTitleCase;
          if ((0, _ramda.has)(disclosureKey, this.props.disclosures)) {
            disclosureText = this.props.disclosures[disclosureKey];
          }
        }
        var dividendsFrequencyLabel = !(0, _functional_utility.isNilOrEmpty)(this.props.dividendsFrequencyLabel) ? _string_utility2.default.renderFormattedLabel(_string_utility2.default.titleCase(this.props.dividendsFrequencyLabel), 'label-for-' + _string_utility2.default.customKebabCase(this.props.dividendsFrequencyLabel)) : this.props.dividendsFrequencyLabel;

        var subTitleVal = this.doesDataPointContains('SHOW_SUB_HEADING_DIVIDEND_DISTRIBUTION_FREQUENCY') && !(0, _functional_utility.isNilOrEmpty)(this.props.distributionFrequencyLabel) ? _string_utility2.default.renderFormattedLabel(_string_utility2.default.titleCase(this.props.distributionFrequencyLabel), 'label-for-' + _string_utility2.default.customKebabCase(this.props.distributionFrequencyLabel)) : dividendsFrequencyLabel;

        headerTitle = (0, _ramda.or)(this.doesDataPointContains('DIVIDEND_HISTORY_TAB'), this.doesDataPointContains("EMEA_DIVIDEND_HISTORY")) ? _string_utility2.default.renderFormattedLabel("Dividend history", 'pdp-dividends-card-label', { fundTypeCode: this.props.fundTypeCode }) : _string_utility2.default.renderFormattedLabel("Dividend Schedule", 'pdp-dividends-card-label', { fundTypeCode: this.props.fundTypeCode });
        headerTitleId = "dividendScheduleCard";
        headerTitleLabel = "dividend-card-header";
        placementId = "pdpCardDividendSchedule";
        dataTest = "dividendSchedule";
        headerLabel = isDataEmpty ? "" : _react2.default.createElement(
          "div",
          { className: "margin-top--25 " + (this.props.breakpoint < 3 ? "display-inline padding-horizontal-16" : "float-right text-right") + " disclaimer2", "data-testid": "dividend-frequency-label" },
          subTitleVal
        );

        if (this.doesDataPointContains('REIT_DIVIDEND_HISTORY') && (0, _functional_utility.pathOrNull)(['data', 0, 'recordDate'], this.props)) {
          var asOfDate = _date_formatter2.default.getEffectiveDateHeader(dataTest, this.props.data[0].recordDate, this.props.country, this.props.role, this.props.breakpoint, "margin-top--25 float-left text-left");
          headerLabel = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            headerLabel,
            _react2.default.createElement("br", null),
            asOfDate
          );
        }

        noDataMessage = _react2.default.createElement(
          "span",
          { "data-testid": "dividend-no-payload-message" },
          _string_utility2.default.renderFormattedLabel("This class has no distributed dividends.", 'pdp-no-distributed-dividend')
        );
        populatedColumns = this.populateDividendYieldColumns();
        dataTestLabel = "dividend";
      } else {
        headerTitle = _string_utility2.default.renderFormattedLabel("Capital Gains Schedule", "pdp-dividends-capital-gains-schedule");
        headerTitleId = "capitalGainsScheduleCard";
        headerTitleLabel = "capital-gains-card-header";
        disclosureText = this.props.disclosures.pdpCardCapitalGainsSchedule;
        placementId = "pdpCardCapitalGainsSchedule";
        headerLabel = isDataEmpty ? "" : _react2.default.createElement(
          "div",
          { className: "margin-top--25 " + (this.props.breakpoint < 3 ? "display-inline padding-horizontal-16" : "float-right text-right") + " disclaimer2", "data-testid": "capital-gains-frequency-label" },
          _string_utility2.default.renderFormattedLabel("Annual", "label-for-annually")
        );
        noDataMessage = _react2.default.createElement(
          "span",
          { "data-testid": "capital-gains-no-payload-message" },
          _string_utility2.default.renderFormattedLabel("This class has no distributed capital gains.", 'pdp-no-distributed-capital-gains')
        );
        populatedColumns = this.populateCapitalGainsColumns();
        dataTestLabel = "capital-gains";
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: headerTitle,
          headerTitleId: headerTitleId,
          headerTitleLabel: headerTitleLabel,
          disclosureText: disclosureText,
          placementId: placementId,
          breakpoint: this.props.breakpoint,
          dataTest: dataTest,
          headerLabel: headerLabel
        },
        this.renderCustomDateRangeDropdown(),
        isDataEmpty ? noDataMessage : this.generateTable(populatedColumns, this.state.filteredData, dataTestLabel),
        this.renderExcelDownload()
      );
    }
  }]);

  return GenericFundDividendsCapitalGainsCard;
}(_react2.default.Component);

exports.default = GenericFundDividendsCapitalGainsCard;